import type { SVGProps } from 'react';
const SvgBusAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#bus_alert_svg__a)">
      <path
        fill="currentColor"
        d="M16 1a7 7 0 0 0-5.78 3.05l.02-.03C9.84 4 9.42 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h8v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08A7 7 0 0 0 16 1ZM4.5 19a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM3 13V8h6c0 1.96.81 3.73 2.11 5H3Zm10.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm2.5-6a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm-1-9h2v5h-2V4Zm0 6h2v2h-2v-2Z"
      />
    </g>
    <defs>
      <clipPath id="bus_alert_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBusAlert;
